import script from "./StickyTop.vue?vue&type=script&lang=js"
export * from "./StickyTop.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__